import script from "./TheSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSignature.vue?vue&type=script&setup=true&lang=js"

import "./TheSignature.vue?vue&type=style&index=0&id=1f095781&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f095781"]])

export default __exports__